import { CreateAbilityMutationProvider } from "__legacy/queries/abilities/CreateAbilityMutationProvider";
import { StakeholderQueryProvider } from "__legacy/queries/stakeholders/StakeholderQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { AbilityForm, onError, onFinish } from "./AbilityForm";

export const New: React.FC<{}> = () => {
  const { stakeholderId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <StakeholderQueryProvider variables={{ id: stakeholderId }}>
      {({ stakeholder }) => (
        <CreateAbilityMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New ability for stakeholder ${stakeholder.companyName}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../")}>Back to abilities</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <AbilityForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { stakeholderId }, {})}
                  values={{}}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateAbilityMutationProvider>
      )}
    </StakeholderQueryProvider>
  );
};
